CertificateSummaryReport.$inject = ['$http', '$state'];
function CertificateSummaryReport($http, $state) {
    return {
        restrict: 'E',
        scope: {programId: '='},
        templateUrl: 'reports/certificateSummary',
        link: function(scope, element, attrs) {
            var reportUrl = '/api/report/certificate/summary';

            if (angular.isDefined(attrs.programId)) {
                scope.$watch('programId', refreshData);
            } else {
                refreshData();
            }

            scope.href = function(year) {
                if (scope.programId) {
                    return $state.href('programReports.certificate', {
                        slug: scope.slug,
                        year: year,
                    })
                } else {
                    return $state.href('reports.certificate', {year: year});
                }
            }


            function refreshData(programId) {
                $http.get(reportUrl + (programId ? '/' + programId : ''))
                .then(function(response) {
                    scope.data = response.data.data;
                    scope.slug = response.data.slug;

                    scope.max = 0;
                    for (var i = 0; i < scope.data.length; i++) {
                        scope.max = Math.max(scope.max, scope.data[i].students)
                    }
                })
            }
        }
    }
}
module.directive('dybCertificateSummaryReport', CertificateSummaryReport);
